import { SVGProps } from 'react';

const SvgPackagePlus = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M6.817 4.331a2.285 2.285 0 0 1 2.366 0l.002.002 4.667 2.8c.356.216.646.523.845.885.2.362.303.769.303 1.18v5.603c0 .411-.104.82-.303 1.181-.2.362-.49.669-.845.885l-.004.002-4.663 2.799h-.002a2.284 2.284 0 0 1-2.366 0h-.002l-4.663-2.799-.004-.002a2.368 2.368 0 0 1-.845-.885A2.455 2.455 0 0 1 1 14.802V9.199c0-.411.104-.82.303-1.181.2-.362.49-.669.845-.885l.004-.002 4.665-2.8ZM9 17.446l3.815-2.29h.001a.37.37 0 0 0 .129-.138A.456.456 0 0 0 13 14.8v-4.182l-4 2v4.828Zm-1-6.564 4.48-2.24-4.332-2.6A.285.285 0 0 0 8 6c-.049 0-.1.013-.148.043l-.004.002L3.52 8.642 8 10.882Zm-5-.264V14.8c0 .08.02.154.055.218a.37.37 0 0 0 .129.138h.001L7 17.447v-4.828l-4-2Z"
      clipRule="evenodd"
    />
    <circle cx={16.5} cy={7.5} r={6.5} fill="#6F7DFF" />
    <path
      fill="#FCFCFC"
      fillRule="evenodd"
      d="M16.5 4.563a.5.5 0 0 1 .5.5V7h1.938a.5.5 0 0 1 0 1H17v1.938a.5.5 0 0 1-1 0V8h-1.938a.5.5 0 0 1 0-1H16V5.062a.5.5 0 0 1 .5-.5Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgPackagePlus;
